import { type LinearConfiguration } from "~/features/configurator/Linear/models";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type CsticUpdate } from "~/features/configurator/Linear/api/sendLinearConfiguratorUpdate";
import { prepareCommonCarriageData, sendCarriage } from "~/features/configurator/Carriage/api/sendCarriageCommon";
import { prepareApiDataForUpdate } from "~/features/configurator/common/commonConfiguratorApi";
import { getMainKmat } from "~/features/configurator/Shaft/common/commonShaftHelpers";
import { FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE } from "~/features/configurator/Carriage/carriageConfiguratorConstants";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import { transform } from "~/features/configurator/Linear/linearDataTransformer";
import { isNonNull } from "~/common/utils/reducers";

export async function sendCarriageUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfiguration> {
  const data = prepareCommonCarriageData(linearState);

  const updateData = prepareApiDataForUpdate(linearState, updatedCstics);

  const response = await sendCarriage({
    ...data,
    ...updateData,
  });

  const oldCstics = getMainKmat({ kmats: linearState.kmats }).cstics;
  const csticsToPreserve = [FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE].map((name) => oldCstics[name]).filter(isNonNull);

  return transform(response, ConfiguratorType.Carriage, csticsToPreserve);
}
